import { useEffect } from "react";

const AW_ID = "AW-18503073404";
const EXCLUDED_PATHS = ["/admin", "/adminup", "/verify-admin-password"];

let injected = false;

/**
 * Balise Google Ads (gtag.js) — chargée sur toutes les pages sauf AdminUp.
 * Le site est une SPA : l'exclusion se fait côté JS selon la route initiale.
 */
const GoogleAdsTag = () => {
  useEffect(() => {
    if (injected) return;
    const path = window.location.pathname.toLowerCase().replace(/\/+$/, "");
    if (EXCLUDED_PATHS.includes(path)) return;

    injected = true;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
    document.head.appendChild(script);

    const inline = document.createElement("script");
    inline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${AW_ID}');
    `;
    document.head.appendChild(inline);
  }, []);

  return null;
};

export default GoogleAdsTag;
